import React from 'react';
import Grid from '@material-ui/core/Grid';
import Lottie from 'react-lottie';
import anim from '../lotties/2628-youre-in.json'
import Teamwork from'../images/Teamwork.jpg'
import Flippy,{FrontSide,BackSide} from 'react-flippy'

function Imag() {
  const imgstyle={
    
    float:"right",
    position:"absolute",
    
    right:40,
    top:120,
  }
  return (
    <div>
      <img style={imgstyle} alt="" src={Teamwork} width="300" height="300"/>
    </div>
  )
}


function Anim() {
  const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData:anim,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

  return (
    <div>
      <Lottie 
	    options={defaultOptions}
        height={400}
        width={400}
      />
    </div>
  );
}

 
function Flip() {

  return (
    <div>
      <Grid container spacing={10}>
        <Grid item>
  <Flippy
    flipOnHover={true} 
    flipOnClick={true} 
    flipDirection="horizontal" 
    style={{ width: '200px', height: '200px',marginLeft:'95px'}}
  >
    <FrontSide
      style={{
        backgroundColor: '#41669d',
        borderRadius:'6px'
      }}
    >
      <h2>DSC</h2>
    
    </FrontSide>
    <BackSide
      style={{ backgroundColor: '#175852'}}>
      <h2>WordsWorth</h2>
    </BackSide>
  </Flippy>
  </Grid>
  <Grid item>
  <Flippy
    flipOnHover={true} 
    flipOnClick={true} 
    flipDirection="vertical" 
    style={{ width: '200px', height: '200px',float:'right'}}
  >
    <FrontSide
      style={{
        backgroundColor: '#41669d',
        borderRadius:'6px'

      }}
    >
      <h2>TechKnights</h2>
      <div>
      
      </div>
    </FrontSide>
    <BackSide
      style={{ backgroundColor: '#175852'}}>
      <h2>MasterBuilders</h2>
      
    </BackSide>
  </Flippy>
  </Grid>
  <Grid item>
  <Flippy
    flipOnHover={true} 
    flipOnClick={false} 
    flipDirection="horizontal" 
    style={{ width: '200px', height: '200px',float:'right'}}
  >
    <FrontSide
      style={{
        backgroundColor: '#41669d',
        borderRadius:'6px'

      }}
    >
      <h2>TechKnights</h2>
    </FrontSide>
    <BackSide
      style={{ backgroundColor: '#175852'}}>
      <h2>FlyingMustangs</h2>
    
    </BackSide>
  </Flippy>
  </Grid>
  </Grid>
  </div>
 
  )
}



export {Anim,Imag,Flip};